// 活動常見問題
'use client';

// 問題
const questions = [
    'Q1.什麼是 CryptoCity 專屬活動？',
    'Q2.如何參與活動，並獲得活動獎勵？',
    'Q3.有哪些任務，可以重複完成嗎？',
    'Q4.完成任務的轉盤，就是抽獎結果嗎？',
    'Q5.抽獎券可以沿用嗎？',
    'Q6.怎麼確認自己是否得獎？是否為中獎者。',
    'Q7.我中獎了，要怎麼兌換獎品？',
    'Q8.我還有問題，可以去哪邊詢問？',
];

// 答案
const answers = [
    '為了讓更多幣圈朋友認識 CryptoCity ，加密城市將不定期舉辦專屬抽獎活動，為支持我們的會員提供獲得優質獎品和限定好禮，所有加密城市的會員都可以參與活動。',
    '我們精心設計了一系列多樣化的活動任務。每當您完成一項任務，就能獲得轉動幸運輪盤的機會。輪盤將隨機發放每日抽獎券，為您贏得抽中大獎的可能。\n在轉動輪盤時，別忘了留意特殊的Bonus區域——若幸運眷顧，您可能會獲得意想不到的額外獎勵。請記住，您收集的抽獎券越多，在當天贏得豐厚獎品的機會就越大。我們鼓勵您積極參與，因為每一次互動都可能帶來驚喜。祝您在活動中玩得開心，收穫滿滿！',
    '任務一共分為兩種：每日、挑戰，每日任務為每天都會重置的任務，挑戰任務則為單次任務，只需在活動期間完成即可。\n無論是完成每日任務還是挑戰任務，您都能獲得轉動幸運輪盤的機會。值得注意的是，每日任務的輪盤啟動機會將在當天結束時重置，而挑戰任務的輪盤啟動機會則可以保留到活動結束前。',
    '完成任務的當下，您都可以獲得一次轉盤機會，轉盤可以獲得數量不等的抽獎券，也可以挑戰Bonus大獎，我們將於每日公告時間進行抽獎，你可以透過任務來重複獲得抽獎券，並持續參加每日的抽獎活動，直到活動結束為止。',
    '很遺憾，每個活動的抽獎券都是獨立的，抽獎卷將於活動結束後失效，如在活動結束前，未進行轉盤，也視同自願放棄權益。',
    '每次轉盤、抽獎結果，我們都會記錄在『中獎紀錄』中，您可以在此確認自己的抽獎結果，也預祝您順利中獎。',
    '恭喜中獎！我們將會發送兌獎通知至您的個人信箱中，請隨時留意，以免錯失兌獎時間，發獎時間為活動結束的兩週後，開始陸續進行發送，還請耐心等待。',
    "您可以透過 <a target='_blank' rel='noreferrer noopener' href='mailto:cs@cryptocity.tw'>聯繫客服</a> ，使用mail與我們聯繫。",
];

const CampaignFaq = () => {
    return (
        <section id="faq" className="bg-[#fff] space-y-[32px]">
            <h3 className="text-[#393939] border-[#393939]">常見問題</h3>

            {new Array(8).fill(0).map((v, i) => (
                <div key={'faq' + i} className="space-y-[2px]">
                    {/* 提問 */}
                    <h4 className="text-bd2b text-[#141414]">{questions[i]}</h4>

                    {/* 答案 */}
                    <p
                        className="text-bd1m text-[#393939] [&>a]:text-[#29AFCB] [&>a]:trans [&>a]:hover:text-[#0c4753]"
                        dangerouslySetInnerHTML={{ __html: answers[i] }}
                    />
                </div>
            ))}
        </section>
    );
};

export default CampaignFaq;
